export const SET_ALL_PROVIDERS = 'SET_ALL_PROVIDERS';
export const SET_PROVIDER = 'SET_PROVIDER';
export const SET_PROFILE_PIC = 'SET_PROFILE_PIC';
